<template>
    <!-- Start Footer -->
    <footer class="relative shadow-2xl border-t border-slate-100">
            <div class="container">
                <div class="grid grid-cols-1">
                    <div class="relative py-12">
                        <!-- Subscribe -->
                        <div class="relative w-full">
                            <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
                                <div class="md:col-span-3">
                                    <a href="#" class="flex justify-center md:justify-start focus:outline-none">
                                        <img src="../assets/images/logo-impuls-long.jpg" class="" alt="">
                                    </a>
                                </div><!--end col-->

                        
                                <div class="md:col-span-9">
                                    <!--<ul class="list-disc footer-list md:text-end text-center mt-5">
                                        <li v-for="item in datas" :key="item" class="inline-block me-3"><router-link :to="item.link" class="text-slate-400 hover:text-amber-300 duration-500 ease-in-out font-medium">{{item.name}}</router-link></li>
                                    </ul>-->
                                    
                                    <p class="footer-list text-end">
                                        <span class='block text-amber-300 font-bold'>Impuls Kinesitherapie</span>
                                        <span class='block'>Dorpsstraat 21</span>
                                        <span class='block'>+ 32 11 33 12 30</span>
                                        <span class='block'>Status: gedeconventioneerd</span>
                                    </p>
                                </div><!--end col-->
                            </div><!--end grid-->
                        </div>
                        <!-- Subscribe -->
                    </div>
                </div>
            </div><!--end container-->

            <div class="py-[30px] px-0 border-t-0 border-slate-400 bg-slate-100">
                <div class="container text-center">
                    <div class="grid md:grid-cols-2 items-center gap-6">
                        <div class="md:text-start text-center">
                            <p class="mb-0 text-slate-400 font-medium">© {{date}} Impuls Kinesitherapie. Design & development by <a href="https://awesam.be/" target="_blank" class="text-reset text-zinc-600">awesam.be</a>.</p>
                        </div>

                        <ul class="list-none md:text-end text-center">
                            <li v-for="item in icons" :key="item" class="inline me-1"><a :href="item.link" target="_blank" class="btn btn-icon btn-sm border-2 border-slate-400 rounded-md hover:border-amber-300 hover:text-zinc-600 hover:bg-amber-300 text-slate-400 duration-500 ease-in-out"><i :class="item.icon" title="Buy Now"></i></a></li>
                        </ul><!--end icon-->
                    </div><!--end grid-->
                </div><!--end container-->
            </div>
        </footer><!--end footer-->
        <!-- End Footer -->
</template>

<script>
    export default {
        data() {
            return {
                date: new Date().getFullYear(),
                icons:[
                    {
                        icon: 'uil uil-dribbble align-middle',
                        link: 'https://dribbble.com/shreethemes'
                    },
                    {
                        icon: 'uil uil-linkedin',
                        link: 'http://linkedin.com/company/shreethemes'
                    },
                    {
                        icon: 'uil uil-facebook-f align-middle',
                        link: 'https://www.facebook.com/shreethemes'
                    },
                    {
                        icon: 'uil uil-instagram align-middle',
                        link: 'https://www.instagram.com/shreethemes/'
                    },
                    {
                        icon: 'uil uil-envelope align-middle',
                        link: 'mailto:support@shreethemes.in'
                    },
                ],
                datas: [
                    {
                        name: 'Home',
                        link: '#home'
                    },
                    {
                        name: 'Diensten',
                        link: '#diensten'
                    },
                    {
                        name: 'Team',
                        link: '#team'
                    },
                    {
                        name: 'Over ons',
                        link: '#about'
                    },
                    {
                        name: 'Contacteer ons',
                        link: 'contact'
                    },
                ]
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>